// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48a7e59d","239":"443a1d68","453":"4aa221e5","667":"099df683"}[chunkId] + ".chunk.js";
};